'use client';

import { StepsFlowEnum } from '@/config/steps.config';
import { useTranslations } from 'next-intl';
import { useParams, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { VpButton } from '@vtmn-play/react';

const WidgetStepsNotFound = () => {
  const t = useTranslations('Widget.pages.steps.notFound');
  const searchParams = useSearchParams();
  const params = useParams();

  const isFromStoreLocator = useMemo(
    () =>
      searchParams?.get('mode') === StepsFlowEnum.STORE_LOCATOR &&
      searchParams?.has('storeId'),
    [searchParams],
  );

  const isFromService = useMemo(
    () =>
      searchParams?.get('mode') === StepsFlowEnum.SERVICE &&
      searchParams?.has('modelId'),
    [searchParams],
  );

  const description = useMemo(() => {
    if (isFromStoreLocator) {
      return t('descriptionFromStoreLocator');
    }

    if (isFromService) {
      return t('descriptionFromService');
    }

    return t('description');
  }, [t, isFromService, isFromStoreLocator]);

  return (
    <main className='flex h-full flex-col items-center justify-center p-4'>
      <h1 className='text-center vp-title-s mb-2'>{t('title')}</h1>
      <h2 className='text-center vp-body-m'>{description}</h2>
      <VpButton
        className='mt-4'
        variant='secondary'
        href={`/country/${params?.countryCode}`}
      >
        {t('buttons.seeOtherStores')}
      </VpButton>
    </main>
  );
};

export default WidgetStepsNotFound;
